export const parseIntFunc = (num) => parseInt(num, 10);

export const formatDelta = (num) => parseIntFunc(num * 100);

export const formatBid = (num) => num.toFixed(2);

export const formatPercent = (num) => Math.round(num * 100, 0);

export const formatPercentFine = (num) => Math.round(num * 10000, 0) / 100;

export const formatVWAP = (num) => (Math.round(num * 100, 0) / 100).toFixed(2);

export const formatIV = (num) =>
  (Math.round(num * 1000, 0) / 10).toFixed(1) + '%';

export const formatVolume = (volume) => {
  if (volume) {
    return volume.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
};

export const formatATMIV = (num) => {
  const data = Math.round(num * 100, 0);
  return isNaN(data) ? '-' : data;
};

export const formatPCHG = (percent) => {
  const data = (Math.round(percent * 1000, 0) / 10).toFixed(1);
  return isNaN(data) ? '-' : data;
};



// WEBPACK FOOTER //
// ./src/utils/numberFormatFunc.js